import React from 'react';
import Hero from './components/administration/engineering-section/Hero';
import Main from './components/administration/engineering-section/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const EngineeringSection = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default EngineeringSection;